import React from 'react'
import { useSearchParams } from 'react-router-dom'
import CreateMemberForm from '../components/Profile-Setting-Sections/create-member-form'

const CreateMember: React.FC = () => {
    const [searchParams] = useSearchParams()
    const editMemberId = searchParams.get('edit')

    return (
        <div className="p-4">
            <div className="w-full mx-auto bg-white rounded-md border border-gray-200 shadow-sm">
                <div className="p-6">
                    <CreateMemberForm memberId={editMemberId ? parseInt(editMemberId, 10) : undefined} />
                </div>
            </div>
        </div>
    )
}

export default CreateMember